import React from "react";
import LoadingBar from "Shared/LoadingBar";
import LoadingMessage from "Shared/LoadingMessage";
import styled from "styled-components";

const LoadingBarContainer = styled("div")`
    margin: 150px 30px 150px;
`;

export default function LoadingModal() {
    return (
        <LoadingBarContainer>
            <LoadingBar />
            <LoadingMessage />
        </LoadingBarContainer>
    );
}
